import * as z from "zod";

import { issueSchema } from "./issue";
import { surrealRecordSchema } from "./surreal-record";

export enum IssueLinkType {
  RELATE = "relate",
  BLOCK = "block",
}

const issueLinkInSchema = surrealRecordSchema.extend({
  in: issueSchema,
  type: z.nativeEnum(IssueLinkType),
});
const issueLinkOutSchema = surrealRecordSchema.extend({
  out: issueSchema,
  type: z.nativeEnum(IssueLinkType),
});

export const issueLinkSchema = z.union([issueLinkInSchema, issueLinkOutSchema]);

export type IssueLink = z.infer<typeof issueLinkSchema>;
